import { styled } from 'styled-components';

export const FilterItemWrapper = styled.div`
  flex: 1;
`;

export default FilterItemWrapper;
